import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/classCountSagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { CustomDateRanges } from "./smartComponents/CustomDateRanges";
import DatePicker from "./smartComponents/DatePicker";
import { Dropdown } from "./smartComponents/Dropdown";
import { UpdateButtons } from "./smartComponents/UpdateButtons";
import TableOrStackedBarChart from "./smartComponents/BarChart";
import { DataPoints } from "./smartComponents/DataPoints";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import "../attendance_common.css.scss";

const ClassCountModule = (props) => {
  const isLoading = useSelector((state) => state.classCount.isLoading);
  const initialRequest = useSelector((state) => state.classCount.initialRequest);
  const updatesLoading = useSelector((state) => state.classCount.updatesLoading);

  const dispatch = useDispatch();

  useEffect(() => {
    !initialRequest && dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div>
              <Dropdown title="Class" slice="class" />
              <Dropdown title="Staff" slice="staff" />
            </div>

            <div className="top-filter__right">
              <div className="select-box-no-width date-range-select-box">
                <p>Date Range</p>
                <CustomDateRanges />
              </div>

              <div className="date-select-box multi">
                <p>Date</p>
                <DatePicker />
              </div>

              <UpdateButtons />
            </div>
          </div>
        </div>

        <div data-testid="charts-container" className="chart-root">
          {updatesLoading ? (
            <LoadingAnimation text="Updating data..." />
          ) : (
            <>
              <DataPoints />
              <TableOrStackedBarChart />
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <div id="attendance-root" className="classCount-module">
      <SectionToggle
        autoHeight
        title="Class Count"
        isLoading={isLoading}
        content={content()}
        learnMore={
          <KBLearnMore
            title="Class Count"
            description="This report shows the total number of scheduled, added, and canceled classes within your selected timeframe. These insights help you evaluate scheduling trends, track class performance, and understand how class volume changes over time."
            kbUrl={ILEARN_URLS.attendance.classCount}
          />
        }
      />
    </div>
  );
};

export default React.memo(ClassCountModule);
